export type SemanticAssetName =
  | 'empty-inbox'
  | 'empty-following'
  | 'empty-collection'
  | 'empty-sent'
  | 'empty-draft'
  | 'empty-starred'
  | 'empty-archive'
  | 'state-error-network'
  | 'empty-public-wall'
  | 'empty-exhibition'
  | 'empty-museum'
  | 'empty-notifications'
  | 'empty-drift-bottle'
  | 'empty-drift-letter'
  | 'drift-intro'
  | 'empty-template'
  | 'empty-envelope'
  | 'empty-persona'
  | 'empty-inspiration'
  | 'empty-match'
  | 'empty-comments'
  | 'empty-review'
  | 'empty-letters-admin'
  | 'empty-users'
  | 'empty-reports'
  | 'empty-config'
  | 'state-not-found';

export const semanticAssets: Record<SemanticAssetName, string> = {
  'empty-inbox': '/semantic-states/empty-inbox.webp',
  'empty-following': '/semantic-states/empty-following.webp',
  'empty-collection': '/semantic-states/empty-collection.webp',
  'empty-sent': '/semantic-states/empty-sent.webp',
  'empty-draft': '/semantic-states/empty-draft.webp',
  'empty-starred': '/semantic-states/empty-starred.webp',
  'empty-archive': '/semantic-states/empty-archive.webp',
  'state-error-network': '/semantic-states/state-error-network.webp',
  'empty-public-wall': '/semantic-states/empty-public-wall.webp',
  'empty-exhibition': '/semantic-states/empty-exhibition.webp',
  'empty-museum': '/semantic-states/empty-museum.webp',
  'empty-notifications': '/semantic-states/empty-notifications.webp',
  'empty-drift-bottle': '/semantic-states/empty-drift-bottle.webp',
  'empty-drift-letter': '/semantic-states/empty-drift-letter.webp',
  'drift-intro': '/semantic-states/drift-intro.webp',
  'empty-template': '/semantic-states/empty-template.webp',
  'empty-envelope': '/semantic-states/empty-envelope.webp',
  'empty-persona': '/semantic-states/empty-persona.webp',
  'empty-inspiration': '/semantic-states/empty-inspiration.webp',
  'empty-match': '/semantic-states/empty-match.webp',
  'empty-comments': '/semantic-states/empty-comments.webp',
  'empty-review': '/semantic-states/empty-review.webp',
  'empty-letters-admin': '/semantic-states/empty-letters-admin.webp',
  'empty-users': '/semantic-states/empty-users.webp',
  'empty-reports': '/semantic-states/empty-reports.webp',
  'empty-config': '/semantic-states/empty-config.webp',
  'state-not-found': '/semantic-states/state-not-found.webp',
};
